import React from 'react';
import { connect } from 'react-redux';
import AppointmentDetails from "./appointmentDetails";
import TaskDetails from "./taskDetails";
import Request from '../../request';
import { FaTasks, FaRegCalendarAlt, FaPhoneSlash, FaGraduationCap } from 'react-icons/fa';
import { Col, Row } from 'antd';
import './css/frontOfficeDashboard.css';
import CallRegisterDetails from './callRegisterDetails';
import TrainingDetails from './trainingDetails';

class TaskAppointments extends React.Component {
    state = {
        showAppointmentDrawar: false,
        showTaskDrawer: false,
        showMissedCallDrawer: false,
        showTrainingDrawer: false,
        tasks: { total: 0, data: [] },
        appointments: { total: 0, data: [] },
        callDetails: { total: 0, data: [] },
        trainings: { total: 0, data: [] },
        drawerParam: {}
    }



    loadAllData = async () => {
        let response = await Request.getDashboardTaskAppointments();
        this.setState(response);
    }

    closeMissedCallDrawer = () => {
        this.setState({ showMissedCallDrawer: false }, () => {
            this.loadAllData();
        })
    }
    closeTrainingDetailDrawer = () => {
        this.setState({ showTrainingDrawer: false }, () => {
            this.loadAllData();
        })
    }


    componentDidMount = () => {
        this.loadAllData();
    }

    render() {
        let { tasks, appointments, showTaskDrawer, drawerParam, showAppointmentDrawar, showMissedCallDrawer, showTrainingDrawer, callDetails, trainings } = this.state;

        return (
            <div className="fod-container">
                <Row className='fod-row'>
                    {
                        showAppointmentDrawar ?
                            <AppointmentDetails appointments={appointments} onClose={() => this.setState({ showAppointmentDrawar: false })} />
                            : null
                    }
                    {
                        showTaskDrawer ?
                            <TaskDetails tasks={tasks} onClose={() => this.setState({ showTaskDrawer: false })} />
                            : null
                    }
                    {
                        showMissedCallDrawer ?
                            <CallRegisterDetails drawerParam={drawerParam} calls={callDetails} onClose={this.closeMissedCallDrawer} />
                            : null
                    }
                    {
                        showTrainingDrawer ?
                            <TrainingDetails drawerParam={drawerParam} data={trainings} onClose={this.closeTrainingDetailDrawer} />
                            : null
                    }
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-tasks">
                                <FaTasks />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Tasks</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ showTaskDrawer: true })}>{tasks.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-3 elevation-1"><FaTasks /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Tasks</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ showTaskDrawer: true })}>{tasks.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card">
                            <div className="stat-icon-wrapper bg-appointments">
                                <FaRegCalendarAlt />
                            </div>
                            <div className="stat-data">
                                <div className="stat-label">Today's Appointments</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a onClick={() => this.setState({ showAppointmentDrawar: true })}>{appointments.total}</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                    {/* <Col span={6}>
                        <div className="info-box glass">
                            <span className="info-box-icon bg-color-4 elevation-1"><FaRegCalendarAlt /></span>
                            <div className="info-box-content">
                                <span className="info-box-text">Today's Appointments</span>
                                <span className="info-box-number">
                                    <a onClick={() => this.setState({ showAppointmentDrawar: true })}>{appointments.total}</a>
                                </span>
                            </div>
                        </div>
                    </Col> */}
                    <Col span={6}>
                        <div className="stat-card missed-calls-card">
                            {/* Updated Wrapper with Soft Red Theme */}
                            <div className="stat-icon-wrapper bg-red">
                                <FaPhoneSlash />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Missed Calls</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            onClick={() => this.setState({
                                                showMissedCallDrawer: true, drawerParam: {
                                                    title: 'Missed Calls',
                                                    data: callDetails.data,
                                                    count: callDetails.total,
                                                    bgColorClass: 'bg-red',
                                                    icon: <FaPhoneSlash />
                                                }
                                            })}
                                        >
                                            {callDetails.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col span={6}>
                        <div className="stat-card missed-calls-card">
                            {/* Updated Wrapper with Soft Red Theme */}
                            <div className="stat-icon-wrapper bg-purple">
                                <FaGraduationCap />
                            </div>

                            <div className="stat-data">
                                <div className="stat-label">Tranings</div>
                                <div className="stat-value">
                                    <span className="info-box-number">
                                        <a
                                            onClick={() => this.setState({
                                                showTrainingDrawer: true, drawerParam: {
                                                    title: 'Trainings',
                                                    data: trainings.data,
                                                    count: trainings.total,
                                                    bgColorClass: 'bg-purple',
                                                    icon: <FaGraduationCap />
                                                }
                                            })}
                                        >
                                            {trainings.total}
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}


const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}


export default connect(mapDispatchToProps)
    (TaskAppointments)